export default "__VITE_ASSET__CYgUyc7q__"